import styled from 'styled-components';
import { LayoutConst } from 'core/modules/layout.module';

export const ToolBarItemWrapperModer = styled.div<{ iconStyles?: boolean }>`
  display: flex;
  align-items: flex-start;
  flex-direction: column-reverse;
  justify-content: space-between;
  cursor: pointer;
  max-width: 32px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: 940px) {
    max-width: initial;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 0;
    justify-content: center;
    box-sizing: border-box;
    margin-right: 0;
    margin-bottom: 0;
    margin-left: 12px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    padding: 0 16px;
    margin: 0;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    padding: 0;
    margin: 0 0 0 12px;
  }
`;

export const ProjectCompetitionsWrapper = styled.div<{
  isBottomTooltip?: boolean
}>`
    display: flex;
    margin-bottom: ${({ isBottomTooltip }) => isBottomTooltip ? 0 : 24}px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin-bottom: ${({ isBottomTooltip }) => isBottomTooltip ? 0 : 16}px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      margin-bottom: 0px;
    }
`
import styled from 'styled-components';
import { LayoutConst } from 'core/modules/layout.module';

export const ToolBarItemWrapperModer = styled.div<{ iconStyles?: boolean }>`
  display: flex;
  align-items: flex-start;
  flex-direction: column-reverse;
  justify-content: space-between;
  cursor: pointer;
  max-width: 32px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: 940px) {
    max-width: initial;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 0;
    justify-content: center;
    box-sizing: border-box;
    margin-right: 0;
    margin-bottom: 0;
    margin-left: 12px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    padding: 0 16px;
    margin: 0;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    padding: 0;
    margin: 0 0 0 12px;
  }
`;

export const ProjectCompetitionsWrapper = styled.div<{
  isBottomTooltip?: boolean
}>`
    display: flex;
    margin-bottom: ${({ isBottomTooltip }) => isBottomTooltip ? 0 : 24}px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin-bottom: ${({ isBottomTooltip }) => isBottomTooltip ? 0 : 16}px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      margin-bottom: 0px;
    }
`
